import {
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalContentProps,
  ModalHeader,
  ModalOverlay,
  ModalProps,
} from '@chakra-ui/react'
import { Trans } from '@lingui/react/macro'
import { colors } from '../theme/cssVariables'
interface FairModalProps extends ModalProps {
  isOpen: boolean
  onClose: () => void
  title?: string
  titleComponent?: React.ReactNode
  hasCloseButton?: boolean
  contentStyle?: ModalContentProps
}
const PopupModal = ({
  isOpen,
  onClose,
  children,
  title,
  titleComponent,
  hasCloseButton = true,
  contentStyle,
  ...props
}: FairModalProps) => {
  return (
    <Modal isOpen={isOpen} onClose={onClose} size={'2xl'} isCentered {...props}>
      <ModalOverlay backdropFilter="blur(4px)" />
      <ModalContent bg={colors.colorB7} color={colors.colorB3} {...contentStyle}>
        <ModalHeader textTransform={'uppercase'} color={colors.colorB1}>
          {titleComponent ? titleComponent : <Trans>{title}</Trans>}
        </ModalHeader>
        {hasCloseButton && (
          <ModalCloseButton
            outline={'none'}
            boxShadow={'none'}
            _focus={{ outline: 'none', boxShadow: 'none' }}
          />
        )}
        <ModalBody display="flex" padding={[1, 6]}>
          {children}
        </ModalBody>
      </ModalContent>
    </Modal>
  )
}

export default PopupModal
